import { HashRouter, Routes, Route } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import { I18nProvider } from '@/lib/i18n';
import Home from '@/pages/Home';
import Resultado from '@/pages/Resultado';
import Layout from '@/components/Layout';

export default function App() {
  return (
    <I18nProvider>
      <HashRouter>
        <Routes>
          <Route
            path={ROUTE_PATHS.HOME}
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route path={ROUTE_PATHS.RESULTADO} element={<Resultado />} />
        </Routes>
      </HashRouter>
    </I18nProvider>
  );
}
